// @core/api/endpoints/task/add_checklist.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AddChecklistRequest,
  TaskResponse,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Add checklist
 * Adds a new checklist with items to the task. Multiple checklists can exist on a single task for organizing subtasks.
 */
export async function AddChecklist(
  task_id: string,
  data: AddChecklistRequest,
  options?: RequestOptions
): Promise<TaskResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/tasks/:task_id/checklists`;
  requestPath = requestPath.replace(':task_id', encodeURIComponent(task_id));
  const requestOptions = options;
  return client.post<TaskResponse>(requestPath, data, requestOptions);
}
